import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { EnsembleErrorBanner } from '../../../app/components/header/styles';
import { EnsembleContext } from '../../../app/context/ensemble-context';
import { useGetUserViewsV2 } from '../../../app/hooks/accounts';
import { TenantSelector } from '../header';
import { Loading } from '../loading/loading';
import withResizableLayout from '../resizable-layout';

import { TabContainer } from './TabbedContainer';

import { Icon } from '@controlrooms/components';
import { ICONS } from '@controlrooms/constants';

const ViewArea = styled.div`
  position: relative;
  flex-grow: 1;
  background: ${({ theme }) => theme.investigate.backgroundColor};
`;

const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const LayoutV2 = ({ children }: { children: React.ReactNode }) => {
  const { isLoading } = useGetUserViewsV2();
  const { showEnsembleErrorBanner, setShowEnsembleErrorBanner } = useContext(EnsembleContext);
  const [searchParams] = useSearchParams();

  return (
    <PanelContainer>
      <div className="top-panel">
        <PanelHeader />
      </div>
      {showEnsembleErrorBanner && (
        <EnsembleErrorBanner>
          <Icon className="icon" name={ICONS.Info} />
          <span data-testid="permission-info">
            {searchParams.get('reference')
              ? `This alert was evaluated by an ensemble family that you are not currently authorized to
            see. The tags from the alert shown below are populated with anomalies from your current
            live ensemble family.`
              : `This shared view was evaluated by an ensemble family that you are not currently authorized to
            see. The view shown below are populated with anomalies from your current
            live ensemble family.`}
          </span>
          <Icon
            className="close"
            name={ICONS.Close}
            onClick={() => {
              setShowEnsembleErrorBanner(false);
            }}
          />
        </EnsembleErrorBanner>
      )}
      {isLoading && (
        <ViewArea>
          <Loading overlay small={true} />
        </ViewArea>
      )}
      {!isLoading && <ViewArea className="view-area">{children}</ViewArea>}
    </PanelContainer>
  );
};

const PanelHeader = withResizableLayout(() => {
  return {
    sidebar: (
      <div style={{ display: 'flex' }}>
        <TenantSelector />
      </div>
    ),
    main: <TabContainer />,
    sidebarOverflow: true,
    mainContentOverflow: true,
  };
});
